'use client';

// Pied de page minimal et soigné : marque, tagline, liens réels, mention.

import Link from 'next/link';

import { useT } from '@/hooks/useT';
import { fontStyle } from '@/theme/typography';

export function LandingFooter() {
  const { t } = useT('landing');

  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <div className="flex flex-col gap-1.5">
          <div className="flex items-center gap-2">
            <span aria-hidden className="size-2.5 rounded-full bg-brand" />
            <span style={fontStyle('subtitle')} className="font-display text-text-primary">
              Remember
            </span>
          </div>
          <span style={fontStyle('bodySm')} className="text-text-tertiary">
            {t('footer.tagline')}
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {[
            { href: '/tarifs', label: t('hero.ctaSecondary') },
            { href: '/sign-in', label: t('nav.signIn') },
            { href: '/sign-up', label: t('nav.signUp') },
          ].map((l) => (
            <Link
              key={l.href}
              href={l.href}
              style={fontStyle('bodySm')}
              className="text-text-secondary transition-colors hover:text-text-primary"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="border-t border-border/60 px-5 py-4 text-center sm:px-8">
        <span style={fontStyle('caption')} className="text-text-tertiary">
          © Remember — {t('footer.rights')}
        </span>
      </div>
    </footer>
  );
}
